export { default as DefaultPage } from './DefaultPage';
export { default as CognitoSignIn } from './SignIn';



// WEBPACK FOOTER //
// ./src/features/cognito/index.js